<template>
  <div class="web-content-option">
    <p id="info-text" class="info-text">
      {{ tStatic('caiWebContentInfoText') }}
    </p>
    <a
      :href="url"
      aria-labelledby="info-text"
      class="link-text"
      rel="noopener noreferrer"
      @click="handleWebContentClick">
      {{ tStatic('caiWebContentLinkText') }}
    </a>
  </div>
</template>

<script>
import gtm from '@/core/enhanced-ecommerce-gtm'

export default {
  props: {
    sessionId: {
      type: String,
      required: true
    },
    url: {
      type: String,
      required: true
    }
  },
  methods: {
    handleWebContentClick(event) {
      event.preventDefault()
      gtm.chatWebContentClick(this.url, this.sessionId)
      window.open(this.url, '_blank')
    }
  }
}
</script>

<style scoped>
.web-content-option {
  margin-top: 10px;
  padding: 10px;
  background-color: #dcedff;
  border-radius: 5px;
}

.info-text {
  margin: 0;
  font-size: 14px;
  color: #333;
}

.link-text {
  display: block;
  margin-top: 5px;
  font-size: 13px;
  color: #0073bb;
  text-decoration: none;
}

.link-text:hover {
  text-decoration: underline;
}
</style>
